import { render, staticRenderFns } from "./bannerDetails.vue?vue&type=template&id=296adf13&"
import script from "./bannerDetails.vue?vue&type=script&lang=js&"
export * from "./bannerDetails.vue?vue&type=script&lang=js&"
import style0 from "./bannerDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports